import { render } from "./animated-icon.vue?vue&type=template&id=525ac7c8"
import script from "./animated-icon.vue?vue&type=script&lang=js"
export * from "./animated-icon.vue?vue&type=script&lang=js"

import exportComponent from "/home/djordje/code/uwp/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__